var size_selected_quick_add = null;

radios = document.querySelectorAll('input[type=radio][name="Color"]');
radios.forEach((radio) => {
    radio.addEventListener("change", () => {
        if (colorContainer) colorContainer.innerHTML = radio.value;
        if (colorContainer2) colorContainer2.innerHTML = radio.value;
        if (colorContainer3) colorContainer3.innerHTML = radio.value;
        updateSizeAvailableQuickAdd(radio.value);
    });

    if (radio.checked) {
        updateSizeAvailableQuickAdd(radio.value, true);
    }
});

function updateSizeAvailableQuickAdd(colorOption, firstRound = false) {
    const variantForm = document.getElementById("quick-add-variants");
    const variants = JSON.parse(variantForm.querySelector('[type="application/json"]').textContent);
    var variantsSize = variantForm.querySelectorAll("[data-pdp-size]");

    size_selected_quick_add = null;
    for (let size of variantsSize) {
        const sizeSelected = size.querySelector("input[type=radio]");
        if ((!size.classList.contains("hidden") || firstRound) && sizeSelected.checked) {
            //if (size.style.display === "block" && sizeSelected.checked) {
            size_selected_quick_add = sizeSelected.value;
            break;
        }
    }

    if (!firstRound) {
        const cachedSizeWrapperQuickAdd = cachedSizeSelectorQuickAdd.cloneNode(true);
        document.querySelector(sizeSelectorIdQuickAdd).replaceWith(cachedSizeWrapperQuickAdd);
    }

    variantsSize = variantForm.querySelectorAll("[data-pdp-size]");

    const variantsFiltered = variants.filter((option) => {
        return option.option1 === colorOption || option.option2 === colorOption;
    });

    variantsSize.forEach((size) => {
        size.classList.add("hidden")
    });

    variantsSize.forEach((size) => {
        variantsFiltered.forEach((variant) => {
            if (size.dataset.pdpSize === variant.option2) {
                size.classList.remove("hidden")
            }
        });
    });

    let optionSelected = false;
    for (let size of variantsSize) {
        if (!size.classList.contains("hidden")) {
            const sizeSelected = size.querySelector("input[type=radio]");
            if (!sizeSelected.dataset.disabled && sizeSelected.value == size_selected_quick_add) {
                sizeSelected.checked = true;
                optionSelected = true;
                break;
            }
        }
    }

    if (!optionSelected) {
        for (let size of variantsSize) {
            if (!size.classList.contains("hidden")) {
                const sizeSelected = size.querySelector("input[type=radio]");
                if (!sizeSelected.dataset.disabled) {
                    sizeSelected.checked = true;
                    size_selected_quick_add = sizeSelected.value;
                    break;
                }
            }
        }
    }

    rebuildCarouselSizeQuickAdd();
}
